import md5 from 'js-md5'

export default class Signature {
    static create (module = '', subTime) {
        let publicKey = 'e7KjHt9MNfz4wgx0aJLBmV6QZvpnAbiq'
        let hex = publicKey + subTime
        return md5(hex)
    }

    static timestamp () {
        return parseInt(Date.parse(new Date()) / 1000)
    }
}




// WEBPACK FOOTER //
// ./src/lib/Signature.js